import { BookingFetchResponseType } from "@models/services/booking";
import { locationType } from "@models/services/organisation";

export const DRAWER_DIRECTION = {
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right",
  TOP: "top",
};

export const KEYBOARD_KEY = {
  ENTER: "Enter",
  ESC: "Escape",
  SPACE: "Space",
};

export const DRAWER_HEIGHT = {
  DEFAULT_OPEN_PERCENT: 95,
  DESKTOP_OPEN_PERCENT: 60,
  FULL: 100,
  HALF: 50,
  LARGE_DESKTOP_OPEN_PERCENT: 66,
  MAX_OPEN_PERCENT: 100,
  MIN_OPEN_PERCENT: 0,
  MOBILE_OPEN_PERCENT: 80,
  SECONDARY_POSITION: 18,
  TABLET_OPEN_PERCENT: 75,
  TWENTY_FIVE_PERCENT: 25,
  ZERO: 0,
};

export const SNAP_POINTS = [
  DRAWER_HEIGHT.ZERO,
  DRAWER_HEIGHT.SECONDARY_POSITION,
  DRAWER_HEIGHT.DEFAULT_OPEN_PERCENT,
] as const;

export type SnapPoint = (typeof SNAP_POINTS)[number];

export const DRAWER_UNITS = {
  UNIT_DVH: "dvh",
  UNIT_VH: "vh",
};

export interface DrawerSnapProps {
  children: React.ReactNode;
  direction?: "bottom";
  isOpen: boolean;
  onClose: () => void;
  useSnapPoints?: boolean;
}

export interface DrawerTimeSlotProps {
  bookingSlots: BookingFetchResponseType;
  isBookingDisable: boolean;
  locationContext?: locationType;
  priceLoader: boolean;
}

export const DRAWER_OVERFLOW = {
  AUTO: "auto",
  EMPTY: "",
  HIDDEN: "hidden",
  SCROLL: "scroll",
};
